import { useHashnodePosts } from "../hooks";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import CustomButton from "../mui-styles/CustomButton";

export default function Posts() {
  const settings = {
    host: "amirahnasihah.hashnode.dev",
    first: 6,
  };
  const { loading, posts } = useHashnodePosts(settings);

  const dateOpt = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={{ xs: 2, md: 3 }}
      >
        {/* {renderPosts} */}
        {loading ? (
          <Typography variant="h5" component="div" sx={{ p: 10 }}>
            Loading...
          </Typography>
        ) : (
          posts.map((post) => {
            return (
              <Grid item xs={12} sm={6} md={5} key={post?.node?.slug}>
                <Card
                  sx={{
                    maxWidth: 345,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <Tooltip title={post?.node?.title}>
                    <Box p={2}>
                      <Typography gutterBottom variant="h6" component="div">
                        {post?.node?.title.slice(0, 50) + "..."}
                      </Typography>
                      <Typography variant="caption">
                        {new Date(post?.node?.publishedAt).toLocaleDateString(
                          "en-MY",
                          dateOpt
                        )}{" "}
                        📅
                      </Typography>
                      <CardMedia
                        component="img"
                        alt={post?.node?.title}
                        height="140"
                        image={post?.node?.coverImage.url}
                        sx={{ borderRadius: "10px 10px 0 0 " }}
                      />
                    </Box>
                  </Tooltip>

                  <Box
                    sx={{
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <CardContent sx={{ height: 120 }}>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          overflow: "auto",
                          maxHeight: "100px",
                          "::-webkit-scrollbar": {
                            display: "none",
                          },
                          cursor: "default",
                        }}
                      >
                        {post?.node?.brief}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <CustomButton
                        variant="contained"
                        size="small"
                        href={`https://amirahnasihah.hashnode.dev/${post?.node?.slug}`}
                        rel="noopener"
                        target="_blank"
                      >
                        read more📖
                      </CustomButton>
                    </CardActions>
                  </Box>
                </Card>
              </Grid>
            );
          })
        )}
      </Grid>
    </Box>
  );
}
